export enum FormInstances {
  AddForm = 'add form',
  EditForm = 'edit form',
}
